var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-margin"},[_c('b-field',{attrs:{"label":_vm.initBlock.config.label,"label-position":"on-border","maxlength":_vm.initBlock.config.maxlength}},[_c('b-input',{attrs:{"value":_vm.initBlock.value.text},on:{"input":_vm.updateValue}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }